// extracted by mini-css-extract-plugin
module.exports = {"prsnIconIndicator":"ParticipantAvatar_prsnIconIndicator__1OafE","prsnIconIndicatorActive":"ParticipantAvatar_prsnIconIndicatorActive__1vI34"};